import {
  useEffect,
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import Pitanje from "../Pitanje/Pitanje";
import anketaService from "../../services/anketa.service";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import "./ViewAnketaPage.css";
import { formatDateTime } from "../../utils/formatDateTime";
import NotFound from "../../components/NotFound"; 
const ViewAnketaPage = forwardRef(
  ({ anketaId, hideExportButton = false }, ref) => {
    const [anketa, setAnketa] = useState(null);
    const [pitanja, setPitanja] = useState([]);
    const exportRef = useRef(null);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await anketaService.getById(anketaId);
          setAnketa(response.data);

          const pitanjaResponse = await anketaService.getPitanjaSaOdgovorima(
            anketaId
          );
          setPitanja(pitanjaResponse.data);
        } catch (error) {
            if (error.response && error.response.status === 404) {
          setNotFound(true);
        } else {
          console.error("Greška pri učitavanju ankete:", error);
        }
      
        }
      };

      if (anketaId) fetchData();
    }, [anketaId]);
 
    const handleExportPDF = async () => {
      if (exportRef.current) {
        try {
          const canvas = await html2canvas(exportRef.current, { scale: 2 });
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF("p", "mm", "a4");
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
          pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
          pdf.save("anketa.pdf");
        } catch (error) {}
      }
    };

    useImperativeHandle(ref, () => ({
      exportToPDF: handleExportPDF,
    }));

       if (notFound) return <NotFound />;
    if (!anketa) return <p>Učitavanje...</p>;

    return (
      <div className="container">
        {!hideExportButton}

        <div ref={exportRef} className="anketa-card">
          <h2 className="modal-title" style={{ width: "90%" }}>
            {anketa.naziv}
          </h2>
          <div className="anketa-info-div">
            <h4 className="anketa-subtitle">{anketa.opis}</h4>
            <p>
              Datum kreiranja: {formatDateTime(anketa.datumKreiranja)}
            </p>
            <p>
              Datum važenja: {formatDateTime(anketa.datumVazenja)}
            </p>
          </div>

          {pitanja
            .sort((a, b) => a.pozicija - b.pozicija)
            .map((p, index) => (
              <Pitanje key={p.id} pitanje={p} />
            ))}
        </div>
      </div>
    );
  }
);

export default ViewAnketaPage;
